<div class="outer-wheel-container">
    <div class="wheel-container">
        <svg [attr.viewBox]="'0 0 200 200'" class="wheel" [style.transform]="'rotate(' + rotation + 'deg)'">
            <g *ngFor="let s of segments()" [class.pulse]="s.selected">
                <path
                    [attr.d]="s.path"
                    [attr.fill]="s.backgroundColor"
                />
                <path
                    [attr.d]="s.outerArcPath"
                    fill="none"
                    [attr.stroke]="s.outerBorderColor"
                    stroke-width="8"
                    stroke-linejoin="round"
                />
                <text
                    [attr.transform]="s.transform"
                    text-anchor="middle"
                    dominant-baseline="middle"
                    [attr.fill]="s.textColor"
                    [attr.font-size]="s.fontSize"
                    font-family="sans-serif"
                    font-weight="bold"
                >
                    <tspan
                        *ngFor="let line of s.titleLines; let i = index"
                        x="0"
                        [attr.dy]="i === 0 ? (-(s.titleLines.length - 1) * 0.6) + 'em' : '1.2em'"
                    >{{ line }}</tspan>
                </text>
            </g>
        </svg>

        <div class="needle">
            <svg width="60px" height="60px" viewBox="0 0 24 24" fill="currentColor">
                <defs>
                    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%" color-interpolation-filters="sRGB">
                        <feDropShadow dx="2" dy="-1" stdDeviation="0.3" flood-color="black" flood-opacity="0.5"/>
                    </filter>
                </defs>

                <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
                    filter="url(#shadow)"
                />
            </svg>
        </div>

        <button (click)="spin()" [disabled]="hasSpun()" #spinButton class="spin-button">
            <div>Click</div>
        </button>
    </div>

    <div class="prize" *ngIf="winningPrizeDisplay">
        <h2>You won:</h2>
        <img [src]="winningPrizeDisplay.image" class="max-" alt="" />
        <i *ngIf="winningPrizeDisplay.type === 'coupon'" class="fa-solid fa-tag fa-3x"></i>
        <h3>{{ winningPrizeDisplay.name }}</h3>
        <h5 class="text-center">{{ standalone ? 'Complete the form to claim your prize.' : 'Your prize will automatically be redeemed once finished.' }}</h5>
    </div>
</div>

<app-win-overlay
    [prize]="overlayVisible() ? winningPrizeDisplay : null"
    [standalone]="standalone"
    (closed)="overlayVisible.set(false); finished.emit()"
/>
